import { useLevel1SectionData } from '../useLevel1Section';

const generalSections = [
  'radio_turns_on',
  'interior_vehicle_odor',
  'keys',
  'air_conditioning',
  'heater',
  'interior_overall'
];

export const useLevel2InteriorSections = () => {
  const { subSections } = useLevel1SectionData('interior_questions');

  return generalSections.map(key => subSections[key]).filter(Boolean);
};
